import { create, windowedFiniteBatchScheduler } from "@yornaath/batshit";
import apiClient from "services/ApiClient";
import { createQueryString } from "helpers/queryString";
import { BATCH_WINDOW_MS } from "helpers/batcher";
import { NewHireJourneyId } from "models/newHire";
import { IssueSummary } from "models/issue";

// Custom resolver that works with keyed object responses
const keyedObjectResolver = (key: string) => (items: Record<NewHireJourneyId, IssueSummary[]>, query: { newHireJourneyId: NewHireJourneyId }) => {
  const journeyId = String(query[key]);
  return items[journeyId] || [];
};

const issuesByJourneyBatcher = create({
  fetcher: async (queries: { newHireJourneyId: NewHireJourneyId }[]): Promise<Record<NewHireJourneyId, IssueSummary[]>> => {
    const journeyIds = queries.map((query) => query.newHireJourneyId);
    const queryString = createQueryString({
      additionalQueries: {
        new_hire_journey_ids: journeyIds,
      },
    });

    // Backend returns { data: { "123": [...], "456": [...] } }
    const response = await apiClient.performRequest<{ data: Record<NewHireJourneyId, IssueSummary[]> }>(
      `/api/issues/batch?${queryString}`,
    );

    return response.payload.data;
  },
  resolver: keyedObjectResolver("newHireJourneyId"),
  scheduler: windowedFiniteBatchScheduler({
    windowMs: BATCH_WINDOW_MS,
    maxBatchSize: 10, // Limit to 10 journeys per request for performance
  }),
});

export default issuesByJourneyBatcher;
